import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread"; //@ts-check

import React from 'react';
import { withStyles, createStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import MissingValue from '../MissingValue';
import { isSpecified } from '../util';

var styles = function styles(theme) {
  return createStyles({
    root: {
      position: 'relative',
      padding: theme.spacing(0.25),
      paddingLeft: theme.spacing(0.5),
      paddingRight: theme.spacing(0.5),
      display: 'inline-block',
      textAlign: 'center',
      textOverflow: 'ellipsis',
      overflowX: 'hidden'
    }
  });
};
/**
 * @param {import('../types').FormatterProps<string> & { color?: string } & import('@material-ui/core').WithStyles<typeof styles, true>} props
 */


var JourneyStage = function JourneyStage(_ref) {
  var value = _ref.value,
      color = _ref.color,
      fallback = _ref.fallback,
      classes = _ref.classes,
      theme = _ref.theme,
      style = _ref.style;
  if (!isSpecified(value)) return fallback;
  var styles = style;

  if (color) {
    styles = _objectSpread({}, styles, {
      backgroundColor: color,
      color: theme.palette.getContrastText(color)
    });
  }

  return React.createElement(Typography, {
    display: "inline",
    style: styles,
    className: classes.root
  }, value);
};

JourneyStage.defaultProps = {
  fallback: React.createElement(MissingValue, null),
  color: '#FFF'
};
export default withStyles(styles, {
  withTheme: true,
  name: 'ECJourneyStage'
})(JourneyStage);